
import * as actionTypes from './actionType';

export const selectInvoice = (invoiceID) => { return {type: actionTypes.SET_INVOICE, 'currentInvoiceID': invoiceID} }
export const doInvoiceUpdate = (invoice) => { return {type: actionTypes.DO_INVOICE_UPDATE, 'performInvoiceUpdate': invoice} }
export const endInvoiceUpdate = () => { return {type: actionTypes.END_INVOICE_UPDATE, 'performInvoiceUpdate': false} }
